import { VideoColorFinderFlight } from "@nova/protobuf"
import { VideoMetadata } from "@nova/slice-video"
import { selectVideoColorFinderFlightById } from "features/entity-caching/flights/selectors"
import { decompress } from "plugins/shared/compression"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import { GenericFlightPathAssetsThumbnail } from "../generics/genericAssetsListThumbnails"

export function VideoColorfinderAssetsThumbnail({ id }: { id: string }) {
    return (
        <GenericFlightPathAssetsThumbnail
            id={id}
            selectEntity={selectVideoColorFinderFlightById}
            getMetadata={getVideoColorfinderMetadata}
        />
    )
}

const getVideoColorfinderMetadata = async (
    entity: VideoColorFinderFlight | undefined,
    demoId?: string
) => {
    if (!entity || !entity.job || "mock" in entity.job) {
        return // Don't support local videos that aren't uploaded yet
    }
    const metadataPath = entity.job.metadataPath
    if (!metadataPath) return Promise.resolve(undefined)
    const s3Key = !!demoId ? `public/sample-data/${metadataPath}` : metadataPath
    const metadataBuffer = await (
        await fileManagementApi.fetchFile(s3Key, { isDemo: !!demoId })
    ).arrayBuffer()
    const metadata = await decompress<VideoMetadata>(metadataBuffer, "msg")
    return metadata
}
